import styled from 'styled-components';

export const PrinterItemInputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 5px;
`;

export const InputHeadingWrapper = styled.div`
    display: flex;
    flex: 0 0 35%;
    max-width: 35%;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 500;
    padding-left: 10px;
    //margin: 0 10px 0 0;
`;

export const InputFieldWrapper = styled.div`
    display: flex;
    flex: 0 0 60%;
    max-width: 60%;
    justify-content: right;
    justify-content: flex-end;
`;

export interface IInputProps {
    isNotValid?: boolean;
}

export const DropdownInputWrapper = styled.div<IInputProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
  
  .dropdown-heading {
        background: #f4f4f4;
        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
    }

    .dropdown-content {
        label {
            padding: 5px;
            margin: 0;
            display: flex;
        }
        input {
            padding: 5px;
            margin: 0;
        }
        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.9rem;
            border-bottom: 1px solid #ddd;
            background: #eee;
        }
        .item-renderer > span {
            display: block;
            margin: 0;
            padding: 0;
            padding-left: 3px;
        }
    }
`;
